import { render, staticRenderFns } from "./BottomBar.vue?vue&type=template&id=4a33d2c9"
import script from "./BottomBar.vue?vue&type=script&lang=js"
export * from "./BottomBar.vue?vue&type=script&lang=js"
import style0 from "./BottomBar.vue?vue&type=style&index=0&id=4a33d2c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports